import EuropeLayoutStyleComponent from "../../../containers/components/europe-2023-layout-style.component";
import EuropeHeader from "../../../components/header/europe-2023-header";

type headerBanner = {
  bannerImage: string;
  headerText: string;
  topCommonMesage: string;
  mobileBanner: string;
};

const Europe2023Banner = (props: headerBanner) => {
  return (
    <>
      <EuropeHeader />
      <EuropeLayoutStyleComponent />

      <Europe2023BannerStyleComponent {...props} />
      <div id="header-image" className="header-image">
        <img src={props.mobileBanner} alt="" className="mobile-image" />
        <div className="top-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: props.topCommonMesage }}></div>
      <div className="bottom-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
    </>
  );
};

export default Europe2023Banner;

const Europe2023BannerStyleComponent = (props: headerBanner) => {
  return (
    <>
      <style>
        {`
        .header-image{
            background-image: url( ${props.bannerImage});
            background-position: center bottom !important;
           
        }
        @media(min-width: 1025px){
            .mobile-image{
                display: none;
            }
        }
        @media(max-width: 1024px){
            .header-image{
                background-image: none
            }  
        }
        @media(max-width: 1024px){
            .top-text{
                display: none;
            } 
        }
        @media(min-width: 1025px){
            .bottom-text{
                display: none;
            }
        }
        .announcement {
            text-align: center;
            font-weight: bold;
            color: #19204A !important;
            background: #8CC7F9 !important;
            padding: 13px 0;
            font-size: 110%;
         }
    `}
      </style>
    </>
  );
};
